export default {
  frontRoutes: [
    {
      path: "/order-confirm/:id",
      name: "OrderConfirm",
      component: () =>
        import(
          /* webpackChunkName: "order" */
          "../views/order/OrderConfirm.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/order-pay/:id",
      name: "OrderPay",
      component: () =>
        import(/* webpackChunkName: "order" */ "../views/order/OrderPay.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/order-success/:id",
      name: "OrderSuccess",
      component: () =>
        import(
          /* webpackChunkName: "order" */
          "../views/order/OrderSuccess.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [
    {
      path: "/member/order",
      name: "MemberOrder",
      component: () =>
        import(
          /* webpackChunkName: "member" */
          "../views/order/MemberOrder.vue"
        ),
      meta: {
        requireAuth: true,
        title: "我的订单",
        root: true,
      },
    },
    {
      path: "/member/order/:id",
      name: "MemberOrderDetail",
      component: () =>
        import(
          /* webpackChunkName: "member" */
          "../views/order/MemberOrderDetail.vue"
        ),
      meta: {
        requireAuth: true,
        title: "订单详情",
      },
    },
  ],
};
